import React, { useEffect, useState, useRef } from "react";
import dayjs from "dayjs";
// import axios from "../../axios/axios";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import Controls from "../../../components/Controls";
import Notification from "../../../components/Notification";
// import { Stack } from "@mui/system";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter } from "@mui/material";

import ClipLoader from "react-spinners/ClipLoader";

import { useGlobalContext } from "../../../context/Context";

export default function DiscountForm(props) {
  const { staffUN, ip, isEditRight, isDeleteRight } = useGlobalContext();

  const [totalPaidRs, setTotalPaidRs] = useState(0);
  const [remarks, setRemarks] = useState("");

  const {
    finalDataForSubmit,
    setFinalDataForSubmit,
    handleSubmitDiscount,
    loading,
  } = props;


  const [notify, setNotify] = React.useState({ isOpen: false, message: "", type: "" });

  const SumTotalPaidRs = () => {
    try {
      let totalRs = finalDataForSubmit.billDetail.reduce((sum, row) => sum + parseFloat(row.netAmt || 0), 0);
      setTotalPaidRs(totalRs.toFixed(2));
    } catch {
      setTotalPaidRs(0);
    }
  };

  useEffect(() => {
    SumTotalPaidRs();
  }, [finalDataForSubmit]);

  const handleChangeDiscAmt = (e, index) => {
    const { value } = e.target;
    const discAmt = parseFloat(value) || 0;
  
    const updatedBillDetail = finalDataForSubmit.billDetail.map((item, idx) => {
      if (idx === index) {
        const taxableAmt = item.amount - discAmt;
        const netAmt = taxableAmt; // Adjust for tax if needed
  
        return {
          ...item,
          discAmt,
          discBy: staffUN,
          // discDate: new Date().toISOString(),
          discDate: dayjs(),
          discIp: ip,
          taxableAmt,
          netAmt,
        };
      }
      return item;
    });
  
    const totalNetAmt = updatedBillDetail.reduce((sum, row) => sum + (parseFloat(row.netAmt) || 0), 0);
  
    setFinalDataForSubmit(prev => ({
      ...prev,
      billDetail: updatedBillDetail,
      paidRs: totalNetAmt.toFixed(2)
    }));
  };
  

  const handleChangeRemarks = (e, index) => {
    const { value } = e.target;
    const updatedBillDetail = finalDataForSubmit.billDetail.map((item, idx) => {
      if (idx === index) {
        const remarks = value || "";
        return {
          ...item,
          remarks,
        };
      }
      return item;
    });

    setFinalDataForSubmit(prev => ({
      ...prev,
      billDetail: updatedBillDetail
    }));
  };



  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TableContainer>
              <Table aria-label="simple Table">
                <TableHead>
                  <TableRow style={{ background: "#e9e9e9" }}>
                    <TableCell>Fee Head Name</TableCell>
                    <TableCell align="center">Charges Amt.</TableCell>
                    <TableCell align="center">Discount Amt.</TableCell>
                    <TableCell align="center">Remarks</TableCell>
                    <TableCell align="center">Net-Amt.</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* {finalDataForSubmit.billDetail.map((row) => ( */}
                  {finalDataForSubmit.billDetail.map((row, index) => (
                    <TableRow key={row._id}>
                      <TableCell align="left" style={{ width: "200px" }}>
                        {row.feeHead}
                      </TableCell>
                      <TableCell align="center" style={{ width: "80px" }}>
                        {row.amount}
                      </TableCell>
                      <TableCell align="center" style={{ width: "80px" }}>
                        <Controls.Input
                          label="DiscAmt"
                          name="discAmt"
                          value={row.discAmt || ""}
                          onChange={(e) => handleChangeDiscAmt(e, index)}
                          type="number"
                        // disabled={!isEditRight}
                        />

                      </TableCell>
                      <TableCell align="center" style={{ width: "80px" }}>
                        <Controls.Input
                          label="remarks"
                          name="remarks"
                          value={row.remarks || ""}
                          onChange={(e) => handleChangeRemarks(e, index)}
                          type="text"
                        />
                        {/* {row.taxableAmt} */}
                        {/* {row.remarks} */}
                      </TableCell>
                      <TableCell align="center" style={{ width: "80px" }}>
                        {row.netAmt}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: "right", fontSize: "large" }}>
                      Total Amount Rs.
                    </TableCell>
                    <TableCell style={{ textAlign: "center", fontSize: "large" }}>
                      <b>{totalPaidRs}</b>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            {/* <Box sx={{ textAlign: "center", m: 2 }}>
              <Controls.Input
                label="Discount Remarks"
                name="remarks"
                value={remarks}
                // onChange={handleChangeFeeHeadSub}
                onChange={(e) => setRemarks(e.target.value)}
                type="text"
                // error={errors.headMain}
                disabled={isEditRight === true ? false : true}
              />
            </Box> */}
            <Box sx={{ textAlign: "center", m: 2 }}>
              <Controls.Button
                text="Save Discount"
                onClick={handleSubmitDiscount}
                // variant="outlined"
                startIcon={<SaveRoundedIcon />}
                size="medium"
                disabled={loading}
              />
              <ClipLoader loading={loading} color="#36d7b7" speedMultiplier={1} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}
